import featured1 from 'common/tp-featured1.svg'
import featured2 from 'common/tp-featured2.svg'
import featured3 from 'common/tp-featured3.svg'
import featured4 from 'common/tp-featured4.svg'
import featured5 from 'common/tp-featured5.svg'
import featured6 from 'common/tp-featured6.svg'
import featured7 from 'common/tp-featured7.svg'
import featured8 from 'common/tp-featured8.svg'
import featured9 from 'common/tp-featured9.svg'

export const CAROUSEL_WIDTH = 1300
export const CAROUSEL_SLIDE_WIDTH = 614

const slidesPerView =
  1 + (CAROUSEL_WIDTH - CAROUSEL_SLIDE_WIDTH) / CAROUSEL_SLIDE_WIDTH

export const SWIPER_CONFIG = {
  slidesPerView: slidesPerView,
  spaceBetween: 0,
  speed: 500,
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 1,
  breakpoints: {
    768: {
      slidesPerView: 1
    }
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  lazy: {
    loadPrevNext: true
  },
  pagination: {
    el: '.tp-Carousel_Pagination',
    clickable: true
  },
  navigation: {
    prevEl: '.tp-Carousel_Button-prev',
    nextEl: '.tp-Carousel_Button-next'
  }
}

export const TOP_PAGE_FEATURED = [
  {
    title: 'Novelties for Exhibitions and Events',
    banner: featured1,
    content: 'For large exhibitions and events, "Clear Files" and "Tote Bags" are popular novelties. Portable items like the "Mini Stainless Bottle" and "Labeled Water" are also in demand.',
    link: '/cms/categories/novelty/exhibition',
    created: '2022/06/09'
  },{
    title: 'Novelties for Open Campus Events',
    banner: featured2,
    content: 'Items like "Pens" that can be used for note-taking during open campus events are popular, as well as organizational items like "Clear Files" and "Tote Bags" for document management. "USB Drives" can also be customized with school or organization names.',
    link: '/cms/categories/novelty/open-campus',
    created: '2021/06/09'
  },{
    title: 'Popular Novelties',
    banner: featured3,
    content: 'We introduce the best-selling novelties at CUSTA, categorized by major categories. The popular categories include "Tote Bags", "T-Shirts", "Towels", and "Masks". Many novelties, promotional items, and commemorative products are created by our customers.',
    link: '/cms/categories/novelty/ranking',
    created: '2022/11/10'
  },{
    title: 'Novelties for Anniversary and Founding Celebrations',
    banner: featured4,
    content: 'Items like "Stainless Tumblers" and "Gift Cards" with printed company or organization names are popular for anniversary and founding celebrations. Items like "Mouse Pads" and "Mobile Batteries" that can be used in the workplace can also be customized with original designs.',
    link: 'cms/categories/novelty/anniversary',
    created: '2021/06/27'
  },{
    title: 'Novelties for Graduation Commemoration',
    banner: featured5,
    content: 'Items like "Tumblers", "Mugs", and "Drawstring Bags" with the names of elementary schools, middle schools, high schools, and universities are popular for graduation commemoration. For a unique touch, "Mobile Batteries" that can charge smartphones on the go can also be personalized as commemorative items.',
    link: '/cms/categories/novelty/graduation-anniversary-gift',
    created: '2021/06/09'
  },{
    title: 'Novelties for Kindergarten Graduation Commemoration',
    banner: featured6,
    content: 'Items like "Mask Cases" and "Drawstring Bags" with the names of kindergartens are popular for kindergarten graduation commemoration. Customized designs on snacks like "Pringles" and "Pocky" are also available.',
    link: '/cms/categories/novelty/kindergarten-graduation-memorial',
    created: '2021/06/09'
  },{
    title: 'Novelties for Distributing to Job Seekers at Company Presentations and Job Fairs',
    banner: featured7,
    content: 'Everyday items like "Masks", "Mask Cases", and "Drawstring Bags" with printed company names are popular for distributing to job seekers at company presentations and job fairs. Items like "Mobile Batteries" that support charging for smartphones are also useful as novelties.',
    link: '/cms/categories/novelty/career-fair',
    created: '2021/06/09'
  },{
    title: 'Recommended Novelties for Winter',
    banner: featured8,
    content: 'Practical and warming items are well-received as novelties to give during the cold winter. Cold-weather items like "Blankets", "Neck Warmers", and "Parkas" are recommended. Additionally, items for enjoying warm drinks like "Thermal Tumblers" and "Mugs" are popular.',
    link: 'cms/categories/novelty/winter',
    created: '2021/06/09'
  },{
    title: 'High-Quality Novelties',
    banner: featured9,
    content: 'We have compiled relatively higher-priced products available at CUSTA, such as "Mobile Batteries" that can be personalized, as well as "Thermo Stainless Bottles" and "Vacuum Insulated Tumblers".',
    link: 'cms/categories/novelty/luxury-company',
    created: '2021/06/09'
  }
]

export const TOP_PAGE_NOVELTIES = [{
  title: 'Understandable  price and delivery time',
  content: 'You can instantly see the price and delivery time based on the product, specifications, and the presence of additional options on the screen.'
}, {
  title: 'Seamless online order experience',
  content: 'We accept orders online 24 hours a day, from choosing products and creating designs to uploading data and issuing quotes. Even without design software, you can enter text data such as company names directly on the site.'
}]

export const TOP_PAGE_FAQ = [{
  title: 'Can you explain how the design editing tool works?',
  content: 'It is a tool that allows you to easily create design data on the website. If you have a logo image for your company or service, you can upload it on the tool and position it to create a design. Even if you don\'t have an image, you can create a design with name input using text input.'
},{
  title: 'What is the sample printing service?',
  content: 'It is a service that allows customers who are anxious about ordering large quantities of expensive items to create samples. You can confirm the actual product and place a full order, so you can use it with confidence even for your first online order. Furthermore, if you use printing with plates, the plate cost will be discounted when placing the full order.'
},{
  title: 'Is it possible to expedite the shipping and delivery date?',
  content: 'We apologize for any inconvenience. The displayed information on the website is already at its shortest. We will continue to work on improvements to allow even shorter delivery times for your orders.'
}]
